import { Configuration, RedirectRequest, PopupRequest } from '@azure/msal-browser'

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin + '/auth/callback',
    postLogoutRedirectUri: window.location.origin + '/login',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage', // Use localStorage for better persistence
    storeAuthStateInCookie: false // Set to true for IE11 support
  }
}

// Add scopes here for ID token to be used at Microsoft Graph API endpoints
export const loginRequest: RedirectRequest = {
  scopes: ['User.Read', 'email', 'profile', 'openid']
}

// Add scopes here for access token to be used at Microsoft Graph API endpoints
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}

export const silentRequest: PopupRequest = {
  scopes: ['User.Read']
}